<template>
  <vs-card v-if="showComponent">
    <div slot="header">
      <h3>Local do Evento</h3>
    </div>
    <div>
      <div class="vx-row">
        <!-- CEP -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="CEP"
            v-mask="'##.###-###'"
            v-model="formEnderecoEvento.cep"
            name="CEP"
            @keyup.native="keymonitor"
          />
        </div>

        <!-- Endereço -->
        <div class="vx-col lg:w-1/3 w-full mb-2">
          <vs-input
            class="w-full"
            label="Endereço"
            v-model="formEnderecoEvento.endereco"
            name="Endereço"
          />
        </div>

        <!-- Número -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="Número"
            v-model="formEnderecoEvento.numero"
            name="Número"
          />
        </div>

        <!-- Complemento -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="Complemento"
            v-model="formEnderecoEvento.complemento"
            name="Complemento"
          />
        </div>
      </div>

      <div class="vx-row mt-4">
        <!-- Bairro -->
        <div class="vx-col lg:w-1/3 w-full mb-2">
          <vs-input
            class="w-full"
            label="Bairro"
            v-model="formEnderecoEvento.bairro"
            name="Bairro"
          />
        </div>

        <!-- Estado -->
        <div class="vx-col lg:w-1/3 w-full mb-2">
          <vs-input
            class="w-full"
            label="Estado"
            v-model="formEnderecoEvento.estado"
            name="Estado"
          />
        </div>

        <!-- Cidade -->
        <div class="vx-col lg:w-1/3 w-full mb-2">
          <vs-input
            class="w-full"
            label="Cidade"
            v-model="formEnderecoEvento.cidade"
            name="Cidade"
          />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col sm:w-1/1 w-full">
          <vs-input
            class="w-full"
            label="Ponto de referência"
            v-model="formEnderecoEvento.pontoReferencia"
            name="Ponto de referência"
          />
        </div>
      </div>

      <div class="vx-row mt-4">
        <!-- Local do acidente sinalizado -->
        <div class="vx-col lg:w-1/3 w-full mb-2">
          <label for class="vs-input--label"
            >Local do acidente sinalizado?</label
          >
          <vs-switch
            v-model="formEnderecoEvento.localSinalizado"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
      </div>

      <!-- Observação sobre o local -->
      <div class="vx-row mt-4">
        <div class="vx-col sm:w-1/1 w-full">
          <p>Observação sobre o local</p>
          <vue-editor
            v-model="formEnderecoEvento.observacaoLocal"
            :editor-toolbar="customToolbar"
            class="w-full"
          ></vue-editor>
        </div>
      </div>
    </div>
  </vs-card>
</template>

<script>
import service from './../../../../../services';
import notify from '../../../../../utils/notify';
import { VueEditor } from 'vue2-editor';
import customToolbar from './../../../../../components/editor/config';
import { decryptData } from './../../../../../services/decryptData';

export default {
  props: ['formData'],
  watch: {
    formData(value) {
      if (!value.enderecoEvento) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - LOCAL EVENTO FORM');
        return;
      }

      this.formEnderecoEvento = Object.assign(
        this.formEnderecoEvento,
        value.enderecoEvento,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.enderecoEvento = this.formEnderecoEvento;
    },
  },
  components: {
    VueEditor,
  },
  data() {
    return {
      customToolbar,
      showComponent: true,
      formEnderecoEvento: {
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        estado: null,
        cidade: null,
        pais: null,
        localSinalizado: null,
        sinalizacao: null,
        observacaoLocal: null,
        pontoReferencia: null,
      },
    };
  },
  methods: {
    keymonitor: async function () {
      if (this.formEnderecoEvento.cep.length == 10) {
        try {
          this.$vs.loading();

          const cepbusca = this.formEnderecoEvento.cep
            .replace('.', '')
            .replace('-', '');

          let result = await service.post('g', 'BuscaCEP', {
            cep: cepbusca,
          });
          result.data = decryptData(result.data);
          this.formEnderecoEvento.endereco = result.data.street;
          this.formEnderecoEvento.bairro = result.data.neighborhood;
          this.formEnderecoEvento.cidade = result.data.city;
          this.formEnderecoEvento.estado = result.data.state;
          this.formEnderecoEvento.pais = result.data.country;
        } catch (error) {
          notify.notifyFail(this.$vs, error);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
  },
  mounted() {
    // if (!this.formData.enderecoEvento) {
    //   console.error('ERRO NO CONTRATO DO OBJETO - LOCAL EVENTO FORM');
    //   this.showComponent = false;
    // }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.enderecoEvento = this.formEnderecoEvento;
  },
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
